import { CellContext } from "@tanstack/react-table";
import { Area, AreaChart, ResponsiveContainer } from "recharts";
import { Trend } from "../../../__generated__/gql/graphql";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function TrendCell({ cell }: CellContext<any, Trend[] | null | undefined>) {
  // Sort the trend data by date in ascending order
  const data = cell.getValue()?.sort((a, b) => {
    return new Date(a.date).getTime() - new Date(b.date).getTime();
  });

  if (!data || !data.length) {
    return null;
  }

  const firstValue = data[0].value;
  const lastValue = data[data.length - 1].value;

  const trendPercent = ((lastValue - firstValue) / firstValue) * 100;

  let stopColor;
  let stroke;

  if (trendPercent > 10) {
    stopColor = "var(--color-success-100)";
    stroke = "var(--color-success-500)";
  } else if (trendPercent > -10) {
    stopColor = "var(--color-gray-200)";
    stroke = "var(--color-gray-400)";
  } else {
    stopColor = "var(--color-warning-100)";
    stroke = "var(--color-warning-500)";
  }

  return (
    <ResponsiveContainer
      width={"100%"}
      height={28}
      style={{ pointerEvents: "none" }}
    >
      <AreaChart
        accessibilityLayer
        data={data}
        margin={{
          left: 0,
          right: 0,
          top: 1,
          bottom: 1,
        }}
      >
        <defs>
          <linearGradient
            id={cell.row.index.toString()}
            x1="0"
            y1="0"
            x2="0"
            y2="1"
          >
            <stop offset="0%" stopColor={stopColor} stopOpacity={1} />
            <stop offset="100%" stopColor={stopColor} stopOpacity={0} />
          </linearGradient>
        </defs>
        <Area
          dataKey="value"
          type="linear"
          fill={`url(#${cell.row.index})`}
          fillOpacity={0.4}
          stroke={stroke}
          strokeWidth={2}
          stackId="a"
          animationDuration={1000}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}

export default TrendCell;
